import React from "react";
import ExerciseLibraryCoachComponent from "../../dashboard/settings/ExerciseLibraryCoachComponent";
import AddSecondaryMovementModal from "../../../parts/modals/add-secondary-movement";
import EditPrimaryMovement from "../../../parts/modals/edit-primary-movement";
import AddOtherExerciseModal from "../../../parts/modals/add-other-exercise";
import JWPlayerVideoModal from "../../../parts/modals/jwplayer-video";
import ExerciseLibraryVideoModal from "../../../parts/modals/ExerciseLibraryVideoModal";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";
import { MOVEMENTS } from "../../../constants";

function View(props, { locals }) {
  const {
    query,
    activeUserToRequest,
    query: { type },
  } = locals;

  let primary = query.primary;

  if (type === "others") {
    primary = "assistant";
  }

  const secondaries = activeUserToRequest.exerciseLibrary?.[primary]?.map(
    (sec, index) => {
      return { ...sec, index, primary };
    }
  );

  return (
    <ExerciseLibraryCoachComponent
      type={type}
      primary={primary}
      secondaries={secondaries}
      activeUserToRequest={activeUserToRequest}
    />
  );
}

const ExerciseLibraryController = async ({ res, req, locals }) => {
  const modal = req.query.modal || {};
  const { athlete, query, activeUserToRequest } = locals;
  const user = athlete || activeUserToRequest;
  const isNew = modal?.index === undefined || modal?.index === null;
  const libraryAssistant = user.exerciseLibrary?.assistant || [];
  const indexAssistant = modal?.index ?? libraryAssistant.length;
  const primary = modal?.primary || "squat";
  const library = user.exerciseLibrary?.[primary] || [];
  const index = modal?.index ?? library.length;
  const modalIndex = locals.query?.modal?.index;
  const intensityMeasure =
    activeUserToRequest.intensityMeasure === "rpe" ? "RPE" : "RiR";
  const isRiR = intensityMeasure === "RiR";

  locals.modal = {
    "add-secondary-movement": (
      <AddSecondaryMovementModal
        isNew={isNew}
        library={library}
        index={index}
        athlete={athlete}
        primary={primary}
        user={activeUserToRequest}
      />
    ),
    "edit-primary-movement": (
      <EditPrimaryMovement
        query={locals.query}
        activeUserToRequest={activeUserToRequest}
        athlete={locals.athlete}
      />
    ),
    "add-other-exercise": (
      <AddOtherExerciseModal
        isNew={isNew}
        library={libraryAssistant}
        index={indexAssistant}
        athlete={athlete}
        intensityMeasure={intensityMeasure}
        isRiR={isRiR}
      />
    ),
    "exercise-library-video": (
      <ExerciseLibraryVideoModal
        exercise={
          modalIndex > -1
            ? library[modalIndex]
            : {
                movement: MOVEMENTS[primary],
                primary,
                ...(activeUserToRequest.primaryExercises &&
                  activeUserToRequest.primaryExercises[primary]),
              }
        }
        athleteId={user._id}
      />
    ),
    "exercise-set-video": <JWPlayerVideoModal mediaId={query.mediaId} />,
    "activity-feed": <ActivityDrawer />,
  }[modal.type];

  req.query.primary ||= "assistant";
  req.query.type ||= "powerlifting";
  res.body = <View />;
};

export default ExerciseLibraryController;
